import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.S12};
`

export const FooterWrapper = styled.div`
  display: flex;
  gap: ${Spacing.S80};
  justify-content: flex-end;
  padding-right: ${Spacing.S24};
`
